import { Component, OnDestroy } from '@angular/core';
import { ViewTaskflowComponent } from 'components/task/taskflow/view-taskflow.component';
import { TaskActionType } from 'enums/TaskActionType';
import { PoolModel } from 'models/generated/Entities.GormCrm.Pool';
import { TaskActionModel } from 'models/generated/Entities.GormCrm.TaskAction';
import { DynamicQueryModel } from 'models/generated/Models.DynamicQuery';
import { QueryPropertyModel } from 'models/generated/Models.QueryProperty';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { ComponentUrl, NavigationService, PageTitle, UrlParam } from 'services/navigation.service';
import { PoolService } from 'services/pool.service';
import { PushService } from 'services/push.service';
import { QueryService } from 'services/query.service';
import { RelationService } from 'services/relation.service';
import { TaskService } from 'services/task.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'list-task-actions',
	templateUrl: './list-task-actions.component.html',
	imports: [Layout, ListView, TranslatePipe, CustomDatePipe]
})
@ComponentUrl('list-task-actions')
export class ListTaskActionsComponent implements OnDestroy {

	taskActions: TaskActionModel[] = [];
	public taskActionType = TaskActionType;
	onTaskflowChanges: Subscription;
	pool?: PoolModel;
	queryData?: DynamicQueryModel;
	highligtedActionId: string | null = null;
	queryProperties?: QueryPropertyModel[];
	activeViewTaskflowComponent?: ViewTaskflowComponent;

	@PageTitle()
	get pageTitle() { return this.pool?.name; }

	@UrlParam
	set poolId(id: string) {
		if (id != undefined && id != '') {
			this.poolService.getPoolById(id).then(pool => {
				this.pool = pool;
				this.updateListOfActions();
				this.navigation.refreshUrl();
			});
		}
		else {
			this.updateListOfActions();
		}
	}
	get poolId() {
		return this.pool && this.pool.id ? this.pool.id : '';
	}

	constructor(private readonly taskService: TaskService
		, private readonly pushService: PushService
		, private readonly navigation: NavigationService
		, private readonly userService: UserService
		, private readonly poolService: PoolService
		, private readonly queryService: QueryService) {

		this.onTaskflowChanges = this.pushService.onTaskflowChanges.subscribe(event => {
			if (this.taskActions
				.filter(r => r.id === event.data.taskActionId)
				.length > 0) {
				this.updateListOfActions();
			}
		});
	}

	updateListOfActions() {
		if (!this.pool) {
			this.taskService.getUsersOpenTaskActionsQuery(this.userService.getCurrentUser().id!).then(actions => this.fillList(actions));
		}
		else if (this.pool.data != undefined && this.pool.data != '') {
			this.queryData = RelationService.instantiateModelsFromData(new DynamicQueryModel(), JSON.parse(this.pool.data));
			this.queryService.executeFilterQuery<TaskActionModel[]>(this.queryData!).then(actions => this.fillList(actions));
		}
	}

	fillList(actions: TaskActionModel[]) {

		actions.forEach((taskAction: TaskActionModel) => {
			if (!taskAction.taskflowId) {
				console.error('TaskAction \'' + taskAction.id! + '\' has no TaskFlow');
				return;
			}
			this.taskActions.push(taskAction);
		});
	}

	selectTaskAction(taskAction: TaskActionModel) {
		this.highligtedActionId = taskAction.id!;
		this.navigation.openRelativeView(this, 'query-views', ViewTaskflowComponent).then(view => {
			this.activeViewTaskflowComponent = view;
			view.selectedActionId = taskAction.id!;
			view.taskflowId = taskAction.taskflowId!;
		});
	}

	gotoTaskAction(taskAction: TaskActionModel) {
		this.navigation.refreshView(ViewTaskflowComponent).then(view => {
			view.selectedActionId = taskAction.id!;
			view.taskflowId = taskAction.taskflowId!;
		});
	}

	ngOnDestroy() {
		this.onTaskflowChanges.unsubscribe();
	}
}
